'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dTwo$002dFactor$002dAuth$002dView$0024$0024anon$002450 from "./presto.-Two-Factor-Auth-View$$anon$50.js";
import * as $j_presto$002e$002dTwo$002dFactor$002dAuth$002dView$0024$0024anon$002452 from "./presto.-Two-Factor-Auth-View$$anon$52.js";
import * as $j_presto$002e$002dTwo$002dFactor$002dAuth$002dView$0024$0024anon$002454 from "./presto.-Two-Factor-Auth-View$$anon$54.js";
import * as $j_presto$002e$002dTwo$002dFactor$002dAuth$002dView$0024$0024anon$002456 from "./presto.-Two-Factor-Auth-View$$anon$56.js";
import * as $j_presto$002etypes$0024$002dTwo$002dFactor$002dAuth$002dUsage$0024 from "./presto.types$-Two-Factor-Auth-Usage$.js";
var $p;
/** @constructor */
function $c_Lpresto_TwoFactorAuthView$$anon$49() {
  this.bDZ = null;
  this.bDR = null;
  this.bDS = false;
  this.bE0 = null;
  this.bE1 = false;
  this.bE4 = null;
  this.bDX = null;
  this.bDY = false;
  this.bDT = null;
  this.bDU = false;
  this.bDV = null;
  this.bDW = false;
  this.bE2 = false;
  this.bE3 = false;
  this.bDZ = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.bE4 = "TwoFactorAuthUsage";
}
export { $c_Lpresto_TwoFactorAuthView$$anon$49 as $c_Lpresto_TwoFactorAuthView$$anon$49 };
$p = $c_Lpresto_TwoFactorAuthView$$anon$49.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_TwoFactorAuthView$$anon$49;
/** @constructor */
function $h_Lpresto_TwoFactorAuthView$$anon$49() {
}
export { $h_Lpresto_TwoFactorAuthView$$anon$49 as $h_Lpresto_TwoFactorAuthView$$anon$49 };
$h_Lpresto_TwoFactorAuthView$$anon$49.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.I = (function() {
  return this.bDZ;
});
$p.L = (function() {
  if ((!this.bDS)) {
    this.bDR = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.bDS = true;
  }
  return this.bDR;
});
$p.O = (function() {
  if ((!this.bE1)) {
    this.bE0 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.bE1 = true;
  }
  return this.bE0;
});
$p.E = (function() {
  return this.bE4;
});
$p.t = (function() {
  if ((!this.bDY)) {
    this.bDX = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("tfa", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("sites", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("credentials", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$())));
    this.bDY = true;
  }
  return this.bDX;
});
$p.M = (function() {
  if ((!this.bDU)) {
    this.bDT = ($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(new $j_presto$002e$002dTwo$002dFactor$002dAuth$002dView$0024$0024anon$002450.$c_Lpresto_TwoFactorAuthView$$anon$50(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Decoder$$anon$44(new $j_presto$002e$002dTwo$002dFactor$002dAuth$002dView$0024$0024anon$002452.$c_Lpresto_TwoFactorAuthView$$anon$52())), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Decoder$$anon$44(new $j_presto$002e$002dTwo$002dFactor$002dAuth$002dView$0024$0024anon$002454.$c_Lpresto_TwoFactorAuthView$$anon$54())), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()))));
    this.bDU = true;
  }
  return this.bDT;
});
$p.Q = (function() {
  if ((!this.bDW)) {
    this.bDV = new $j_presto$002e$002dTwo$002dFactor$002dAuth$002dView$0024$0024anon$002456.$c_Lpresto_TwoFactorAuthView$$anon$56();
    this.bDW = true;
  }
  return this.bDV;
});
$p.w = (function() {
  if ((!this.bE3)) {
    this.bE2 = false;
    this.bE3 = true;
  }
  return this.bE2;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee562) => ((p) => \u03b4scrutinee562.z3(p)))($j_presto$002etypes$0024$002dTwo$002dFactor$002dAuth$002dUsage$0024.$m_Lpresto_types$TwoFactorAuthUsage$())));
});
var $d_Lpresto_TwoFactorAuthView$$anon$49 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_TwoFactorAuthView$$anon$49, "presto.TwoFactorAuthView$$anon$49", ({
  SL: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_TwoFactorAuthView$$anon$49 as $d_Lpresto_TwoFactorAuthView$$anon$49 };
//# sourceMappingURL=presto.-Two-Factor-Auth-View$$anon$49.js.map
